import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get_transaction_by_beneficiary_id } from '../api/transaction_api';
import '../styles/Transactions.css'
import { delete_transaction_by_id } from '../api/transaction_api';

const formatDate = (value) => {
    if (!value) return '—';

    const dateOnly = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(value);

    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
};

const Transactions = ({ beneficiary }) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const data = await get_transaction_by_beneficiary_id(beneficiary.id);
                setTransactions(data);
            } catch (err) {
                setError('טעינת הפעולת נכשלה.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        if (beneficiary.id) {
            fetchTransactions();
        }
    }, [beneficiary.id]);

    if (loading) return <p>טוען את הפעולות...</p>;
    if (error) return <p>{error}</p>;

    const handleDelete = async (id) => {
        if (window.confirm("האם אתה בטוח שברצונך למחוק את הפעולה?")) {
            try {
                await delete_transaction_by_id(id);
                setTransactions(transactions.filter((t) => t.id !== id));
            } catch (err) {
                console.error("מחיקת הפעולה נכשלה:", err);
                alert("שגיאה במחיקת הפעולה.");
            }
        }
    };

    const handleUpdate = async (id) => {
        navigate(`update_transaction/${id}`, {
            state: { beneficiaryName: `${beneficiary.first_name} ${beneficiary.last_name}` }
        });
    };
    
    return (
        <div className="transactions-container">
            <h2 className="transactions-title">פעולות</h2>
            {transactions.length === 0 ? (
                <p>אין פעולות בכרטסת זו</p>
            ) : (
                <table className="transactions-table">
                    <thead>
                        <tr>
                            <th>שם ספק</th>
                            <th>אופן תשלום</th>
                            <th>סעיף</th>
                            <th>סכום</th>
                            <th>תאריך שיק</th>
                            <th>תאריך</th>
                            <th>הערות</th>
                            <th>פעולות</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((t) => (
                            <tr key={t.id}>
                                <td>{t.provider_name}</td>
                                <td>{t.payment_method}</td>
                                <td>{t.category}</td>
                                <td>₪{t.amount}</td>
                                <td>{formatDate(t.check_date)}</td>
                                <td>{formatDate(t.date)}</td>
                                <td>{t.comments || '—'}</td>
                                <td className="action-cell">
                                    <button className="icon-btn" title="עדכן" onClick={() => handleUpdate(t.id)}>
                                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M12 20h9" />
                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                        </svg>
                                    </button>
                                    <button className="icon-btn" title="מחק" onClick={() => handleDelete(t.id)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M3 5.5H17M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5M9 8.5V15.5M11 8.5V15.5M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Transactions;
